"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var NotificationContext_1 = require("./NotificationContext");
var useNotification = function () {
    var _a = NotificationContext_1.useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var queueMessage = react_1.useCallback(function (_a) {
        var title = _a.title, rest = tslib_1.__rest(_a, ["title"]);
        enqueueSnackbar(title, tslib_1.__assign({ preventDuplicate: true, persist: true, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            } }, rest));
    }, [enqueueSnackbar]);
    return { queueMessage: queueMessage, closeMessage: closeSnackbar };
};
exports.default = useNotification;
